export default __webpack_public_path__ + "static/media/en_black.8c4986ee.svg";